import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CommonService } from 'src/app/shared/services/common.service';
import * as fromRoot from '../../../state/app.state';
import { SearchService } from './search.service';

@Injectable()
export class SearchEffects {

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private searchService: SearchService,
    private actions: Actions,
  ) {

  }


}
